<template lang="pug">
.lucre-logo

  visual(:image='logo'
    load='visible'
    offset='200'
    alt="Lucre Games Logo - Indie Game Studio in Sacramento")
</template>

<script>
export default {
  name: 'lucre-logo',

  data() {
    return { logo: require('@/assets/images/lucre-games-indie-game-sacramento-logo-white.png')}
  }
}
</script>

<style lang="stylus">

.lucre-logo
  .vv-visual 
    max-width rem(140px)
    margin 0 auto 
</style>



// WEBPACK FOOTER //
// src/components/global/LucreLogo.vue